export const arenaEnvironments = [
    { name: 'Dev', value: 'dev' },
    { name: 'Staging', value: 'staging' },
    { name: 'Canary', value: 'canary' },
    { name: 'Production', value: 'prod' },
    { name: 'Test', value: 'test' },
];

export const arkcomEnvironments = [
    { name: 'Dev', value: 'dev' },
    { name: 'Staging', value: 'stage' },
    { name: 'Production', value: 'prod' },
];

export const aarpEnvironments = [
    { name: 'Stage', value: 'stage' },
    { name: 'Production', value: 'prod' },
];
